import { Model } from "../../features/models/types/model";
import { AppThunk } from "../store";
import * as api from "../../utils/API";
import { GetUnderwriteModelApiResponse } from "../../features/models/api/api-types";
import axios from "axios";
import { toModel } from "../../utils/models";

export const RECEIVE_HISTORY_MODEL = "RECEIVE_HISTORY_MODEL";
export const MAX_HISTORY_MODEL = "MAX_HISTORY_MODEL";

export type ReceiveModelHistoryAction = {
  type: typeof RECEIVE_HISTORY_MODEL;
  data: Model;
};

export type MaxHistoryAction = {
  type: typeof MAX_HISTORY_MODEL;
  modelID: number;
  history: number;
};
const fetchHistory = async (
  modelID: number,
  history?: number
): Promise<Model | null> => {
  let r = await axios.get<GetUnderwriteModelApiResponse>(
    `${`/api/v1/Underwriting/Models`}/${modelID}`,
    {
      params: {
        history: history,
      },
    }
  );
  return toModel(r.data);
};
export const getHistory =
  (m: number, history: number): AppThunk =>
  async (dispatch) => {
    try {
      const model = await fetchHistory(m, history);

      if (model) {
        dispatch({ type: RECEIVE_HISTORY_MODEL, data: model });
      } else {
        dispatch({ type: MAX_HISTORY_MODEL, modelID: m, history: history - 1 });
      }
    } catch (err) {
      console.log("error", err);
      throw err;
    }
};
